const PHONE_USER_AGENT_PATTERN =
  /iPhone|iPod|Android.+Mobile|Windows Phone|IEMobile|Opera Mini|BlackBerry|webOS/i;

export function detectPhoneDevice(
  navigatorValue = typeof window === "undefined" ? undefined : window.navigator
) {
  if (!navigatorValue) return false;

  if (typeof navigatorValue.userAgentData?.mobile === "boolean") {
    return navigatorValue.userAgentData.mobile;
  }

  return PHONE_USER_AGENT_PATTERN.test(String(navigatorValue.userAgent || ""));
}
